import React from 'react';
import PropTypes from 'prop-types';

import styles from './treadwell-icon.scss';

function TreadwellIcon(props) {
  const { rank } = props;

  return (
    <>
      <div className={styles['rank']}>#{rank}</div>
      <img
        alt="Treadwell"
        src="https://discounttire.scene7.com/is/content/discounttire/logos/treadwell-icon-only-trademark-on-white.svg"
      />
    </>
  );
}

TreadwellIcon.propTypes = {
  rank: PropTypes.number
};

export default TreadwellIcon;
